import { Column, Columns } from '@components/Columns';
import { Container } from '@components/Container';
import { Link, RouterLink } from '@components/Link';
import React from 'react';
import { size } from 'src/layout/helpers';
import styled from 'styled-components';

interface IFooterLinks {
  text: string;
  title: string;
  path: string;
  routerLink?: boolean;
}

interface IFooter {
  links: IFooterLinks[];
  copyright?: string;
}

const PublicFooter = ({ links, copyright }: IFooter) => (
  <Wrapper>
    <Container>
      <Columns $spacing={4} $clearLtSm>
        <Column $grow>{copyright}</Column>
        {links && links.length > 0 && (
          <Column>
            <Columns $spacing={4} $flexWrap>
              {links.map((link, i) => (
                <Column key={`${link.path}-${i}`}>
                  {link.routerLink ? (
                    <RouterLink to={link.path} title={link.title} $currentColor>
                      {link.text}
                    </RouterLink>
                  ) : (
                    <Link href={link.path} title={link.title} $currentColor>
                      {link.text}
                    </Link>
                  )}
                </Column>
              ))}
            </Columns>
          </Column>
        )}
      </Columns>
    </Container>
  </Wrapper>
);

export default PublicFooter;

const Wrapper = styled.footer`
  background-color: ${(props) => props.theme.color.primary.anthracite};
  color: ${(props) => props.theme.color.text.inverted};
  padding: ${size(7)} 0;
  padding-bottom: calc(${size(7)} + env(safe-area-inset-bottom));

  a {
    &:hover {
      color: ${(props) => props.theme.color.text.inverted};
      text-decoration: underline;
    }
  }
`;
